module.exports = __webpack_public_path__ + "assets/switch.67ff45e5.svg";